import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import $ from 'jquery';
import ReactExport from 'react-data-export';
import { CSVLink } from 'react-csv';
import { push } from 'connected-react-router';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import { testWindow } from '../Wrappers/MainWindow';
import Frame from '../Wrappers/Frame';
import { Row, Col } from '../Grid';
import { offer, user, enm } from '../../services/api';
import ModalQuestion from '../ModalQuestion';
import Checkbox from '../Checkbox';
import downloadIcon from '../../svg/download.svg';
import './Offer.css';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const askSanBarcodeByPhone = 'web_tool_ask_bar_code_by_phone';

const shipmentStatuses = {
  unknown: '',
  preparing: 'Preparing',
  shipped: 'In Transit',
  delivered: 'Delivered',
  dropped: 'Delivered',
  failure: 'Failure',
  cancelled: 'Cancelled',
};

interface Props {
  id: string;
  match: any;
  push: Function;
}

interface State {
  offer: Offer | null;
  attendee: any | null;
  attendees: Array<any>;
  carriers: Array<any>;
  carrier: string | undefined;
  tracking_number: string;
  ask_scan_by_phone: boolean;
  popup_title: string;
  is_processing: boolean;
  is_editable: boolean;
  export_format: string | null;
}

class OfferShipment extends React.Component<Props, State> {
  state: State = {
    offer: null,
    attendee: null,
    attendees: [],
    carriers: [],
    carrier: undefined,
    tracking_number: '',
    ask_scan_by_phone: false,
    popup_title: '',
    is_processing: false,
    is_editable: false,
    export_format: null,
  };

  componentDidMount() {
    enm.getCarriers().then((data: any) => {
      this.setState({ carriers: data.data });
    });

    user.getProperty(askSanBarcodeByPhone, true).then((data: any) => {
      this.setState({ ask_scan_by_phone: data.data[askSanBarcodeByPhone] === 'true' });
    });

    offer.getById(this.props.match.params.id).then((data: any) => {
      this.setState({ offer: data.data });
      this.setState({ attendees: data.data.attendees.filter((a) => a.status !== 'canceled') });
      this.setState({
        is_editable:
          data.data.gift_source === 'manual' &&
          (data.data.deliberation_status === undefined ||
            data.data.deliberation_status === 'finalized'),
      });
    });
  }

  sendPushNotification() {
    offer.sendPushToAddTracking(this.state.attendee.id).then((data: any) => {});
  }

  addTrackingNumber() {
    this.setState({ is_processing: true });

    offer
      .setTrackingNumber(this.state.attendee.id, this.state.tracking_number, this.state.carrier)
      .then((data: any) => {
        let a = this.state.attendee;
        a.shipment.tracking_number = this.state.tracking_number;

        this.setState({ attendee: a });

        $('#add_tracking_number').modal('hide');
      })
      .catch((error: any) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.code === 'carrier_is_unknown'
        ) {
          $('#add_tracking_number').modal('hide');
          $('#choose_carrier').modal('show');
        }
      })
      .finally(() => {
        this.setState({ is_processing: false });
      });
  }

  exportAttendees() {
    let attendees: any[] = [];

    this.state.attendees.forEach((attendee) => {
      attendees.push({
        tracking_status: attendee.shipment.tracking_status
          ? shipmentStatuses[attendee.shipment.tracking_status]
          : null,
        tracking_number: attendee.shipment.tracking_number
          ? attendee.shipment.tracking_number
          : null,
        first_name: attendee.model.first_name ? attendee.model.first_name : null,
        last_name: attendee.model.last_name ? attendee.model.last_name : null,
        address: attendee.shipment.address
          ? attendee.shipment.address.address1 + ' ' + attendee.shipment.address.address2
          : null,
        city: attendee.shipment.address ? attendee.shipment.address.city : null,
        state: attendee.shipment.address ? attendee.shipment.address.state : null,
        postal_code: attendee.shipment.address ? attendee.shipment.address.postal_code : null,
      });
    });

    return attendees;
  }

  markAsDelivered(a) {
    let attendees = this.state.attendees.map((attendee) => {
      if (attendee.id === a.id) {
        offer.checkIn(a.id);

        attendee.shipment.status = 'delivered';
      }

      return attendee;
    });

    this.setState({ attendees: attendees });
  }

  onDeliveredClick(a) {
    if (a.shipment.status !== 'delivered') {
      this.setState({ attendee: a });

      $('#mark_as_delivered').modal('show');
    }
  }

  onAddTrackingClick(attendee: any, title: string) {
    this.setState({
      attendee: attendee,
      carrier: undefined,
      tracking_number: attendee.shipment.tracking_number,
      popup_title: title,
    });

    $('#tracking_number').val(attendee.shipment.tracking_number);

    if (this.state.ask_scan_by_phone === true) {
      $('#ask_scan_by_phone').modal('show');

      this.setState({ ask_scan_by_phone: false });

      user
        .setProperty(askSanBarcodeByPhone, 'false', moment().add(100, 'year').format())
        .then((data: any) => {});
    } else {
      $('#add_tracking_number').modal('show');
    }
  }

  render() {
    return (
      <Row>
        <ModalQuestion
          function={() => {
            this.sendPushNotification();
          }}
          cancelFunction={() => {
            $('#add_tracking_number').modal('show');
          }}
          id="ask_scan_by_phone"
          title="Scan Barcode"
          leftName="NO"
          rightName="YES"
        >
          Do you want to enter tracking
          <br /> by scanning with your phone?
          <br />
          We'll send you a push
          <br /> notification to get you started.
        </ModalQuestion>

        <ModalQuestion
          function={() => {
            this.markAsDelivered(this.state.attendee);
          }}
          cancelFunction={() => {
            $('#mark_as_delivered').modal('hide');
          }}
          id="mark_as_delivered"
          title="Mark as Delivered"
          leftName="NO"
          rightName="YES"
        >
          Do you want to mark this gift as
          <br /> delivered? {this.state.attendee ? this.state.attendee.model.name : ''} will
          <br /> be notified.
        </ModalQuestion>
        <div className="modal fade" id="add_tracking_number" aria-hidden="true">
          <div className="modal-dialog modal-md">
            <div className="modal-content" style={{ width: '450px' }}>
              <div
                className="modal-header"
                style={{ border: 'none', paddingBottom: '0', paddingTop: '10px' }}
              >
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 className="modal-title"> </h4>
              </div>
              <div className="modal-body">
                <div className="col-lg-12 text-center ">
                  <span className="add_tracking_number__heading">{this.state.popup_title}</span>
                </div>
                <div className="row" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div className="col-lg-3 text-center">
                    <img
                      style={{ borderRadius: '50%', width: '60px', height: '60px' }}
                      src={this.state.attendee ? this.state.attendee.model.avatar : null}
                      alt="Attendee"
                    />
                  </div>
                  <div className="col-lg-9">
                    <strong className="add_tracking_number__model_information add_tracking_number__model_information--bold">
                      {this.state.attendee ? this.state.attendee.model.name : null}
                    </strong>
                    <span className="add_tracking_number__model_information">
                      {this.state.attendee && this.state.attendee.shipment.address
                        ? this.state.attendee.shipment.address.address1
                        : ''}
                    </span>
                    <span className="add_tracking_number__model_information">
                      {this.state.attendee && this.state.attendee.shipment.address
                        ? this.state.attendee.shipment.address.city
                        : ''}
                    </span>
                  </div>
                  <div className="col-lg-12" style={{ marginTop: '20px' }}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="tracking_number"
                        className="form-control custom-input"
                        onChange={(e: any) => {
                          this.setState({ tracking_number: e.target.value });
                        }}
                        placeholder="Enter Tracking Number"
                      />
                      <div className="input-group-append">
                        {this.state.is_processing === false ? (
                          <button
                            id="add_tracking_number__OK"
                            className="btn custom-button"
                            onClick={() => this.addTrackingNumber()}
                            disabled={this.state.is_processing}
                          >
                            OK
                          </button>
                        ) : null}

                        {this.state.is_processing ? (
                          <span className="add_tracking_number__ajax_loader">
                            <img src="/img/ajax-loader.gif" alt="Loading" />
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 text-center">
                    <span
                      className="add_tracking_number__scan_with_phone"
                      onClick={() => {
                        this.sendPushNotification();
                        $('#add_tracking_number').modal('hide');
                      }}
                    >
                      Scan barcode with phone instead
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="choose_carrier" aria-hidden="true">
          <div className="modal-dialog modal-md">
            <div className="modal-content" style={{ width: '450px' }}>
              <div
                className="modal-header"
                style={{ border: 'none', paddingBottom: '0', paddingTop: '10px' }}
              ></div>
              <div className="modal-body">
                <div className="col-lg-12 text-center ">
                  <span className="add_tracking_number__heading">Choose Carrier</span>
                </div>
                <div className="col-lg-12 text-center">
                  <span className="add_tracking_number__text">
                    We couldn’t determine which carrier you’re using. Please choose from the list
                    below.
                  </span>
                </div>

                <div className="row">
                  <div className="col-lg-3" style={{ marginTop: '10px' }}></div>
                  <div className="col-lg-6" style={{ marginTop: '10px' }}>
                    {this.state.carriers &&
                      this.state.carriers.map((carrier) => (
                        <div className="radio">
                          <label title={carrier.title}>
                            <input
                              style={{ height: '10px', width: '10px', marginRight: '20px' }}
                              value={carrier.code}
                              name="carrier"
                              type="radio"
                              onChange={(e: any) => {
                                this.setState({ carrier: e.target.value });
                              }}
                            />
                            <img height="10" src={carrier.logo_url} alt="Carrier" />
                            <span className="add_tracking_number__carrier">{carrier.title}</span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="modal-footer" style={{ border: 0, padding: 0 }}>
                <button
                  disabled={this.state.carrier === null}
                  className="btn add_tracking_number__save"
                  onClick={() => {
                    $('#choose_carrier').modal('hide');
                    $('#add_tracking_number').modal('show');
                    $('#add_tracking_number__OK').click();
                  }}
                >
                  SAVE
                </button>
              </div>
            </div>
          </div>
        </div>

        <Col size="12">
          <Frame
            title={
              <span>
                <span>{`${
                  this.state.offer !== null
                    ? this.state.offer.subtitle + ': Ship & Track'
                    : 'Ship & Track'
                }`}</span>
                <span style={{ display: 'inline-block', float: 'right' }}>
                  <DropdownButton
                    drop="down"
                    id="attendees_export"
                    title={<img width="25" height="25" src={downloadIcon} alt="Download" />}
                    variant={'none'}
                  >
                    <CSVLink
                      className={'dropdown-item'}
                      filename={`attendees_` + (this.state.offer ? this.state.offer.id : null)}
                      style={{ backgroundColor: '#e8e2ce', color: '#55555' }}
                      data={this.exportAttendees()}
                    >
                      CSV
                    </CSVLink>
                    <Dropdown.Item>
                      <ExcelFile
                        filename={`attendees_` + (this.state.offer ? this.state.offer.id : null)}
                        element={
                          <span style={{ width: '100%', display: 'inline-block' }}>XLSX</span>
                        }
                      >
                        <ExcelSheet data={this.exportAttendees()} name="Attendees">
                          <ExcelColumn label="Status" value="tracking_status" />
                          <ExcelColumn label="Tracking" value="tracking_number" />
                          <ExcelColumn label="First" value="first_name" />
                          <ExcelColumn label="Last" value="last_name" />
                          <ExcelColumn label="Address" value="address" />
                          <ExcelColumn label="City" value="city" />
                          <ExcelColumn label="State" value="state" />
                          <ExcelColumn label="ZIP" value="postal_code" />
                        </ExcelSheet>
                      </ExcelFile>
                    </Dropdown.Item>
                  </DropdownButton>
                </span>
              </span>
            }
            fullHeight={false}
          >
            <table className="table attendees-table">
              <thead>
                <tr>
                  <th>STATUS</th>
                  {this.state.offer !== null && this.state.offer.gift_source !== 'no_tracking' ? (
                    <th></th>
                  ) : (
                    ''
                  )}
                  {this.state.offer !== null && this.state.offer.gift_source !== 'no_tracking' ? (
                    <th>TRACKING</th>
                  ) : (
                    ''
                  )}
                  <th>FIRST</th>
                  <th>LAST</th>
                  <th>ADDRESS</th>
                  <th>CITY</th>
                  <th>STATE</th>
                  <th>ZIP</th>
                </tr>
              </thead>
              <tbody>
                {this.state.attendees &&
                  this.state.attendees.map((attendee: any) => (
                    <tr key={attendee.id}>
                      {this.state.offer !== null &&
                      this.state.offer.gift_source === 'no_tracking' ? (
                        <td>
                          <span style={{ marginRight: '10px' }}>
                            <Checkbox
                              status={attendee.shipment && attendee.shipment.status === 'delivered'}
                              flip={() => {
                                this.onDeliveredClick(attendee);
                              }}
                            />
                          </span>
                          Delivered
                        </td>
                      ) : (
                        <td className="shipment-status">
                          {attendee.shipment.status
                            ? shipmentStatuses[attendee.shipment.status]
                            : ''}
                        </td>
                      )}

                      {this.state.offer !== null &&
                      this.state.offer.gift_source !== 'no_tracking' ? (
                        <td>
                          {attendee.shipment.carrier ? (
                            <img
                              alt="Carrier logo"
                              height="10px"
                              src={attendee.shipment.carrier.logo_url + ''}
                            />
                          ) : null}
                        </td>
                      ) : (
                        ''
                      )}

                      {this.state.offer !== null &&
                      this.state.offer.gift_source !== 'no_tracking' ? (
                        <td>
                          {attendee.shipment.tracking_number ? (
                            <span style={{ whiteSpace: 'nowrap' }}>
                              <span style={{ lineHeight: '15px' }}>
                                {attendee.shipment.tracking_url ? (
                                  <a
                                    className="edit_tracking"
                                    href={attendee.shipment.tracking_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {attendee.shipment.tracking_number}
                                  </a>
                                ) : (
                                  <span>{attendee.shipment.tracking_number}</span>
                                )}
                              </span>
                              {this.state.is_editable ? (
                                <span style={{ marginLeft: '10px' }}>
                                  <img
                                    onClick={() => {
                                      return this.onAddTrackingClick(attendee, 'Edit Tracking');
                                    }}
                                    style={{
                                      height: '15px',
                                      width: '15px',
                                      marginTop: '-5px',
                                      cursor: 'pointer',
                                    }}
                                    src="/img/edit@3x.png"
                                    alt="Edit"
                                  />
                                </span>
                              ) : null}
                            </span>
                          ) : this.state.is_editable ? (
                            <span
                              onClick={() => this.onAddTrackingClick(attendee, 'Add Tracking')}
                              className="add_tracking"
                            >
                              + Add
                            </span>
                          ) : null}
                        </td>
                      ) : (
                        ''
                      )}

                      <td>{attendee.model.first_name}</td>
                      <td>{attendee.model.last_name}</td>
                      <td>
                        {attendee.shipment.address
                          ? attendee.shipment.address.address1 +
                            ' ' +
                            attendee.shipment.address.address2
                          : ''}
                      </td>
                      <td>{attendee.shipment.address ? attendee.shipment.address.city : ''}</td>
                      <td>{attendee.shipment.address ? attendee.shipment.address.state : ''}</td>
                      <td>
                        {attendee.shipment.address ? attendee.shipment.address.postal_code : ''}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </Frame>
        </Col>
      </Row>
    );
  }
}

export default connect(null, { push })(testWindow(OfferShipment, 'offers'));
